const ShareCrypto = require("./ShareCrypto.js");
const StoreCrypto = require("./StoreCrypto.js");

const GenerateTempPassword = require("./GenerateTempPassword.js");

// to build out during sign up, but then deleted once done
let signup = {
  uid: "",
  name: "",
  nameSaved: false,
  email: "",
  emailSaved: false,
  emailCode: "",
  emailCodeSaved: false,
  phone: "",
  phoneSaved: false,
  phoneCode: "420024",
  phoneCodeSaved: false,
  username: "",
  usernameSaved: false,
  password: "",
  passwordSaved: false,
  tempPassword: "",
  distanceEvents: 0,
  distanceFriends: 0,
  distanceSaved: false,
  birthday: "",
  birthdaySaved: false,
  gender: -1,
  genderSaved: false,
  agePreference: [],
  agePreferenceSaved: false,
  lookingFor: [],
  lookingForSaved: false,
  photos: [],
  photosSaved: false,
  photoIds: [],
  interests: [],
  interestsSaved: false,
  questions: [],
  questionsSaved: false,
  bio: "",
  bioSaved: false,
  lat: 0,
  long: 0,
  locationSaved: false,
  socialLinks: [],
  socialLinksSaved: false,
  keys: "",
  keysSaved: false,
  signupComplete: false,
}

// let signupNoTransferFields = ["uid", "name", "phone", "password", "tempPassword", "distanceEvents", "distanceFriends", "birthday", "gender", "agePreference", "lookingFor", "interests", "questions", "keys", ]

// to store on the local device and in s3 - syncs on to new devices
let store = {
  uid: "",
  name: "",
  email: "",
  phone: "",
  username: "",
  distanceEvents: 0,
  distanceFriends: 0,
  birthday: "",
  gender: "",
  agePreference: [],
  lookingFor: [],
  photoIds: [],
  interests: [],
  questions: [],
  lat: 0,
  long: 0,
  bio: "",
  socialLinks: [],
}

// to share with others
let share = {
  uid: "",
  name: "",
  username: "",
  birthday: "", // store MSB style, "1976-02-29"
  gender: 0, // store using Gender.js "i"
  lookingFor: [], // store like [1,7,11] - based on Gender.js "i"
  agePreference: [], // [20,40]
  photoIds: [], // reference / pointer to pic ids
  interests: [], // store like [1, 13, ...]
  questions: [], // store like [1, 5, ...] each element pos indicates the question
  lat: 0,
  long: 0,
  bio: "",
  socialLinks: [],
}
let shareNoTransferFields = ["email", "phone", "distanceEvents", "distanceFriends", ];

let loaded = false;

module.exports = {
  
  load: () => {
    if (loaded == false) {
      signup = JSON.parse( localStorage.getItem("signup") );
      store = JSON.parse( localStorage.getItem("store") );
      share = JSON.parse( localStorage.getItem("share") );
    }
  },
  
  
  createPersonalDefault: () => {
    
    // make sure we have a default object sitting there waiting for us
    if (localStorage.getItem("signup") == null) {
      // set default signup object
      localStorage.setItem("signup", JSON.stringify(signup) );
    }
    
    // make sure we have a default object sitting there waiting for us
    if (localStorage.getItem("store") == null) {
      // set default signup object
      localStorage.setItem("store", JSON.stringify(store) );
    }
    
    // make sure we have a default object sitting there waiting for us
    if (localStorage.getItem("share") == null) {
      // set default signup object
      localStorage.setItem("share", JSON.stringify(share) );
    }
    
  },
  
  
  verifyPersonalObject: () => {
    if (localStorage.getItem("signup") == null) {
      throw "Must start from beginning";
    }
    
    // check invite code
    // need the JSON.parse because v comes back as a string, not a boolean
    let v = JSON.parse( localStorage.getItem("v") );
    let vc = localStorage.getItem("vc");
    
    if (v == false || vc == "") {
      throw "Verification Code does not exist";
    }
    
    // console.log("signup.uid:", signup.uid);
    // console.log("store.uid:", store.uid);
    // console.log("share.uid:", share.uid);
    
    // load local variables from localStorage
    if (signup.uid == "") signup = JSON.parse(localStorage.getItem("signup") );
    if (store.uid == "") store = JSON.parse(localStorage.getItem("store") );
    if (share.uid == "") share = JSON.parse(localStorage.getItem("share") );
    
    // console.log("signup:", signup);
    // console.log("store:", store);
    // console.log("share:", share);
  },
  
  
  getPersonalObject: (key) => {
    let out = localStorage.getItem("signup");
    if (out == null) return false;
    return JSON.parse(out)[key];
  },
  
  
  // a debug routine - just to add fields without having to restart the signup process
  // addTo is an array that points to what you want to add to.
  // [1,1,1] = add to signup, store, share
  
  // Signup.addPersonalObject("photoIds", [], [1,1,1]);
  
  addPersonalObject: (key, value, addTo) => {
    if (addTo[0] == true) {
      let s = JSON.parse(localStorage.getItem("signup"));
      s[key] = value;
      localStorage.setItem("signup", JSON.stringify(s) );
    }
    
    if (addTo[1] == true) {
      let s = JSON.parse(localStorage.getItem("store"));
      s[key] = value;
      localStorage.setItem("store", JSON.stringify(s) );
    }
    
    if (addTo[2] == true) {
      let s = JSON.parse(localStorage.getItem("share"));
      s[key] = value;
      localStorage.setItem("share", JSON.stringify(s) );
    }
    
  },
  
  
  // a debug routine - deletes a key from specified objects
  // removeFrom is an array that points to what you want to remove from.
  // [1,1,1] = remove from signup, store, share

  // Signup.deleteFromObject("photos", [0,1,1]);
  
  deleteFromObject: (key, removeFrom) => {
    
    if (removeFrom[0] == true) {
      let s = JSON.parse(localStorage.getItem("signup"));
      delete s[key];
      localStorage.setItem("signup", JSON.stringify(s) );
    }
    
    if (removeFrom[1] == true) {
      let s = JSON.parse(localStorage.getItem("store"));
      delete s[key];
      localStorage.setItem("store", JSON.stringify(s) );
    }
    
    if (removeFrom[2] == true) {
      let s = JSON.parse(localStorage.getItem("share"));
      delete s[key];
      localStorage.setItem("share", JSON.stringify(s) );
    }
    
  },
  
  
  saveToPersonalObject: (key, value) => {
    if (key in signup) {
      let s = JSON.parse(localStorage.getItem("signup"));
      s[key] = value;
      localStorage.setItem("signup", JSON.stringify(s) );
      signup[key] = value;
    }
    
    if (key in store) {
      // console.log("key:", key);
      let s = JSON.parse(localStorage.getItem("store"));
      s[key] = value;
      localStorage.setItem("store", JSON.stringify(s) );
      store[key] = value;
    }
    
    if (key in share) {
      let s = JSON.parse(localStorage.getItem("share"));
      s[key] = value;
      localStorage.setItem("share", JSON.stringify(s) );
      share[key] = value;
    }
    
  },
  
  
  setupNewUser: async () => {
    let uid = module.exports.getPersonalObject("uid");
    let vc = localStorage.getItem("vc"); // invite code
    
    // if we have a uid already, we've already gone through the 
    // setupNewUser process.  so, we'll skip it...
    if (uid != "" || vc == "") return;
    
    let password = GenerateTempPassword.now();
    module.exports.saveToPersonalObject("password", password);
    module.exports.saveToPersonalObject("tempPassword", password);
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    
    const res = await fetch("https://routes.hot0.workers.dev/setupNewUser", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        password, password,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      module.exports.saveToPersonalObject("uid", data);
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        // document.location = "http://hot:5000/#/signup/profile/type";
        document.location = "/";
      }
    }
    
  },
  
  
  saveKeys: async () => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let keys = module.exports.getPersonalObject("keys");
    let vc = localStorage.getItem("vc"); // invite code
    
    // console.log("keys:", keys);
    
    const res = await fetch("https://routes.hot0.workers.dev/saveKeys", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        cert: keys.cert,
        pkey: keys.pkey,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
    
  },
  
  
  saveMe: async (fkey) => {
    
    // console.log("saveMe key:", fkey);
    
    if (fkey == undefined) {
      console.error("sync(key) - key is undefined");
      return;
    }
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let vc = localStorage.getItem("vc"); // invite code
    
    // console.log("saveMe signup:", signup);
    
    // encrypt store - store in s3
    let estore = StoreCrypto.encrypt(JSON.stringify(store), signup.keys.cert);
    // console.log("estore:", estore);
    // console.log("estore.length:", estore.length);
    
    let send = {
      cookie: cookie,
      csrf: csrf,
      vc: vc,
      store: estore,
      share: "",
    }
    
    // there are certain keys where we don't want to trigger a re-encryption and a retransfer
    if (shareNoTransferFields.includes(fkey) == false || fkey == "lat,long") {
      // encrypt share - store in s3
      send.share = ShareCrypto.encrypt(share);
    }
    
    // console.log("send:", send);
    
    // return;
    
    const res = await fetch("https://routes.hot0.workers.dev/saveMe", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(send),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
      throw "There was a server error";
    }
    
  },
  
  
  isEmailUsed: async (email) => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/isEmailUsed", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        email: email
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      if (data == "-") throw "thumbsDown";
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
  },
  
  
  saveEmail: async () => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let email = module.exports.getPersonalObject("email");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/saveEmail", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        email: email,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
  },
  
  
  verifyEmail: async (verifyCode) => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let uid = module.exports.getPersonalObject("uid");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/verifyEmail", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        verifyCode: verifyCode,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      if (data == "-") throw "bad";
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
    
  },
  
  
  savePhone: async () => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let phone = module.exports.getPersonalObject("phone");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/savePhone", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        phone: phone,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
    
  },
  
  
  verifyPhone: async (verifyCode) => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/verifyPhone", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        verifyCode: verifyCode,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      if (data == "-") throw "bad";
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
    
  },
  
  
  isUsernameUsed: async (username) => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/isUsernameUsed", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        username: username,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      if (data == "-") throw "thumbsDown";
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
  },
  
  
  saveUsername: async () => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let username = module.exports.getPersonalObject("username");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/saveUsername", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        username: username,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
    
  },
  
  
  savePasswordAndPrivateKey: async () => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let password = module.exports.getPersonalObject("password");
    let keys = module.exports.getPersonalObject("keys");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/savePasswordAndPrivateKey", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        password: password,
        pkey: keys.pkey,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
    
  },
  
  
  saveProfilePhotos: async () => {
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let photos = module.exports.getPersonalObject("photos");
    let vc = localStorage.getItem("vc"); // invite code
    
    // first we save the photos and their ids
    const res = await fetch("https://routes.hot0.workers.dev/saveProfilePhotos", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        photos: photos,
        toDelete: [],
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      // then we save just the ids to /me
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
    
  },
  
  
  saveLocation: async () => {
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    let lat = module.exports.getPersonalObject("lat");
    let long = module.exports.getPersonalObject("long");
    let vc = localStorage.getItem("vc"); // invite code
    
    const res = await fetch("https://routes.hot0.workers.dev/saveLocation", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        vc: vc,
        lat: lat,
        long: long,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
    } else {
      console.log("there was a server error");
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        document.location = "/";
      }
    }
  },

}